import { Container } from 'react-bootstrap';  

function FooterComponent(){
	return (
		<div className="box mt-5">
		  <Container>
				<div className="footer">
					<div id='footer-text'>
						<div className='disclaimer'>
							Website content Owned and Managed By Finance Department.
						</div>
						Designed and Developed By <a target='_blank' href='https://manipur.nic.in'><u>NIC Manipur </u></a><br/>
						<a target='_blank' href='https://manipur.nic.in'>
							<img src="/images/nic1.png" width="100"/>	
						</a>
					</div>
				</div>
		  </Container>
		</div>
	)
}
export default FooterComponent